import React from 'react';
import { DateTime } from 'luxon';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import InputDatePicker from 'app/components/DatePicker/InputDatePicker';
import useCalendarPreferences from 'app/utils/hooks/useCalendarPreferences';

const DateSelector = React.forwardRef((props: any, _ref) => {
  const { t } = useTranslation();
  const { name, disabled, control, maxDate, minDate, 'data-testid': dataTestId } = props;
  const { preferences } = useCalendarPreferences();

  const { field } = useController({ name, control });

  const date = field.value
    ? (DateTime.isDateTime(field.value) ? field.value : DateTime.fromJSDate(field.value))
    : null;

  return (
    <InputDatePicker
      placeholderText={t('Select Date')}
      setDate={(d) => field.onChange(d?.toJSDate ? d.toJSDate() : d)}
      date={date}
      disabled={disabled}
      maxDate={maxDate}
      minDate={minDate}
      data-testid={dataTestId}
      portalId="root"
      dateFormat={preferences.dateFormat}
      calendarStartDay={preferences?.firstDay}
    />
  );
});

export default DateSelector;
